export default "__VITE_PUBLIC_ASSET__865de424__"